'use strict';

customerZone.controller('TopupController', ['$log', '$location', '$timeout', 'Session', 'config', 'utils',
    'SubscriptionService', 'ProductService', 'BalanceService', 'OrderService', 'salesAnalytics', 'errorCode',
    'BudskapClient', '$q', function($log, $location, $timeout, Session, config, utils, SubscriptionService,
        ProductService, BalanceService, OrderService, salesAnalytics, errorCode, BudskapClient, $q){

        var self = this;

        var POLL_INTERVAL_MSECS = 1500;
        var UNSUPPORTED_STATES = [
            jim.SubscriptionState.disabled,
            jim.SubscriptionState.pending,
            jim.SubscriptionState.deleted];


        var TOPUP_STATE = {
            WAIT_FOR_PAYMENT: 'WAIT_FOR_PAYMENT',
            PROCESSING: 'PROCESSING',
            DONE: 'DONE',
            TOPUP_ERROR: 'TOPUP_ERROR',
            PAYMENT_ERROR: 'PAYMENT_ERROR',
            PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
            NO_ORDER: 'NO_ORDER'
        };

        self.loading = false;
        self.subscriber = null;
        self.product = null;
        self.toppedUp = false;
        self.paymentMethodSelection = null; // this will be injected by the component

        self.products = [];

        self.buyTopup = function(){
            if (self.loading) return;
            self.loading = utils.translate('topup');

            salesAnalytics.signalCheckout(0, 'topup', [self.product], undefined, 'topup');
            SubscriptionService.buyTopup(self.subscriber.id, self.product.id,
                self.paymentMethodSelection.getPaymentMethod, config.eserviceUrl+'#!/reload?order={ORDER_ID}')
                .then(function(order){
                    if (order.paymentUrl)
                        utils.redirect(order.paymentUrl);
                    else {
                        $location.search('order', order.id);
                        pollOrderState();
                    }
                }, function(error){
                    self.loading = false;
                    if (errorCode.is(error, errorCode.USER_IN_DUNNING)){
                        utils.showError('cannot_topup_while_in_dunning');
                        return;
                    }
                    $log.error('Failed to buy options: ', error);
                    utils.showError();
                });
        };

        var init = function(){
            self.subscriber = Session.subscriber();

            var promises = [];

            self.prerequisites = self.subscriber && self.subscriber.isPrepaid() && self.subscriber.sim  &&
                !UNSUPPORTED_STATES.includes(self.subscriber.state);
            if (!pollOrderState())
                promises.push(loadTopupProducts());

            $q.all(promises)
                .then(function(){
                    self.loading = false;
                })
                .catch(function(error){
                    $log.error('something went south with promises in topup controller', error);
                });
        };

        var loadTopupProducts = function(){
            self.loading = utils.translate('loading_data');

            return ProductService.getTopupProducts().then(function(products){
                self.products = products;
            }).catch(function(error){
                $log.error('Could not load topup products', error);
                utils.showError();
            });
        };

        /**
         * Start polling for the state of the current order
         * @return {boolean} true if there is indeed an order to poll for (postback mode)
         */
        var pollOrderState = function(){
            var orderId = $location.search()['order'];
            if (orderId) {

                var getOrderState = function(){
                    return SubscriptionService.getOrder(orderId);
                };

                var stopCondition = function(order){
                    if (!order.state) return false;
                    if (order.state === jim.OrderState.enabled) return true;
                };

                var untilNotWaitingForPayment = function(order){
                    if (!order) return true;
                    if (!order.state) return false;
                    return order.state !== jim.OrderState.waiting_for_payment;
                };

                self.toppingUp = TOPUP_STATE.WAIT_FOR_PAYMENT;

                utils.poll(getOrderState, untilNotWaitingForPayment, POLL_INTERVAL_MSECS, 10000, 'paying done')
                    .then(function(order) {
                        if (!order) throw TOPUP_STATE.NO_ORDER;
                        if (order.state === jim.OrderState.cancelled)
                            throw errorCode.wrap(errorCode.PAYMENT_CANCELLED);
                        if (order.state === jim.OrderState.failed)
                            throw  errorCode.wrap(errorCode.PAYMENT_CANCELLED);
                        if (order.state === jim.OrderState.review_needed) {
                            throw errorCode.wrap(errorCode.PAYMENT_REQUIRES_REVIEW);
                        }
                        return salesAnalytics.signalPurchase(order, 'topup')
                            .then(function(){
                                self.toppingUp = TOPUP_STATE.PROCESSING;
                                return utils.poll(getOrderState, stopCondition, POLL_INTERVAL_MSECS, 300000,
                                    'order processing');
                            });
                    })
                    .then(function(){
                        self.toppingUp = TOPUP_STATE.DONE;
                        BalanceService.refresh();
                    })
                    .catch(function(error){
                        self.toppingUp = undefined;
                        self.error = true;
                        if (error === TOPUP_STATE.NO_ORDER){
                            self.toppingUp = TOPUP_STATE.NO_ORDER;
                        }
                        else if (errorCode.is(error, errorCode.PAYMENT_CANCELLED))
                            self.toppingUp = TOPUP_STATE.PAYMENT_CANCELLED;
                        else if (error.pollTimeout === 'paying done')
                            self.toppingUp = TOPUP_STATE.PAYMENT_ERROR;
                        else {
                            self.toppingUp = TOPUP_STATE.TOPUP_ERROR;
                            $log.error('Failure during order state poll: ', error);
                        }
                    });

                return true;
            }
        };

        init();

    }]);
